"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostAgencyAndTravelAgentCount = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
let HostAgencyAndTravelAgentCount = class HostAgencyAndTravelAgentCount {
    _id;
    name;
    approvedTravelAgentCount;
    discountCoefficient;
    commissionPercentage;
};
exports.HostAgencyAndTravelAgentCount = HostAgencyAndTravelAgentCount;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgencyAndTravelAgentCount.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], HostAgencyAndTravelAgentCount.prototype, "name", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, type_graphql_1.Field)(() => type_graphql_1.Int),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsInt)(),
    __metadata("design:type", Number)
], HostAgencyAndTravelAgentCount.prototype, "approvedTravelAgentCount", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(1),
    __metadata("design:type", Number)
], HostAgencyAndTravelAgentCount.prototype, "discountCoefficient", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_validator_1.Max)(100),
    __metadata("design:type", Number)
], HostAgencyAndTravelAgentCount.prototype, "commissionPercentage", void 0);
exports.HostAgencyAndTravelAgentCount = HostAgencyAndTravelAgentCount = __decorate([
    (0, type_graphql_1.ObjectType)("HostAgency")
], HostAgencyAndTravelAgentCount);
//# sourceMappingURL=HostAgencyAndTravelAgentCount.js.map